export default __webpack_public_path__ + "static/media/guv-4.5b120b16.png";